export class FilterRuleDTO{

    public id!: number;
    public inputFieldReference!: string;
    public filterRuleDefinitionId!: number;
    public filterParameter!: string;

}